export function getSubsidiaries(state) {
    return state.subsidiaries;
}

export function getUserSubsidiary(state) {
    return state.user_subsidiary;
}

export function getProductsSubsidiary(state) {
    return state.products_by_subsidiary;
}

export function getRentOperations(state) {
    return state.rent_operations;
}
